export const piece = {
 "meta": {
  "title": "Le Crapaud et le Berger",
  "subtitle": "ou Les Nouveaux Plaideurs",
  "badge": "Farce en trois actes et en vers",
  "author": "Gilles de Chassey",
  "credit": "librement inspirée des Plaideurs de Jean Racine (1668) et d’une histoire vraie de la baie du Mont-Saint-Michel",
  "edition": "VIVA ARTIST · 2026 · 20 € · ISBN 979-10-4356-892-3"
 },
 "blocks": [
  {
   "type": "text",
   "text": "LE CRAPAUD ET LE BERGER"
  },
  {
   "type": "text",
   "text": "ou Les Nouveaux Plaideurs"
  },
  {
   "type": "text",
   "text": "Farce en trois actes et en vers"
  },
  {
   "type": "text",
   "text": "librement inspirée des Plaideurs de Jean Racine (1668)"
  },
  {
   "type": "text",
   "text": "et d'une histoire vraie de la baie du Mont-Saint-Michel"
  },
  {
   "type": "text",
   "text": "par Gilles de Chassey, descendant de Jean Racine"
  },
  {
   "type": "text",
   "text": "Créée au théâtre d'Avranches à l'été 2026, puis représentée au Prieuré Saint-Léonard et à la bergerie de François"
  },
  {
   "type": "text",
   "text": "Cerbonney, le Berger de la baie."
  },
  {
   "type": "text",
   "text": "Une production VIVA ARTIST, le label de production tous médias du Prieuré Saint-Léonard"
  },
  {
   "type": "text",
   "text": "À mon aïeul Jean,"
  },
  {
   "type": "text",
   "text": "à ma famille,"
  },
  {
   "type": "text",
   "text": "au père Joseph Racapé, inlassable pédagogue tout donné à Jésus,"
  },
  {
   "type": "text",
   "text": "à François,"
  },
  {
   "type": "text",
   "text": "à Zacharia."
  },
  {
   "type": "speech",
   "speaker": "AVERTISSEMENT DE L'AUTEUR",
   "lines": [
    "On me pardonnera, j'espère, d'avoir pillé mon aïeul. Jean Racine n'écrivit qu'une seule",
    "comédie, Les Plaideurs ; trois cent soixante ans plus tard, son descendant n'a rien trouvé de",
    "mieux que de la lui voler. C'est un procédé de famille : Racine lui-même avait pris son juge",
    "chez Aristophane. Je ne plagie donc pas, je perpétue.",
    "Mon aïeul avait tiré sa farce d'un procès véritable. J'ai fait de même. Chacun, dans la baie,",
    "connaît l'histoire du Berger et de sa bergerie de bois : vingt ans de procédures, quatre refus",
    "de permis, un permis accordé, un permis annulé, un ministre désavoué par un tribunal, des",
    "astreintes, des appels, des pourvois, des mises en demeure — et au bout du compte, un",
    "homme, quatre cents moutons de prés-salés et une charpente de bois sur terre battue",
    "sommés de disparaître du paysage qu'ils entretiennent. Il ne manquait à cette affaire qu'un",
    "poète pour en rire, puisqu'il était interdit d'en pleurer.",
    "Toute ressemblance entre l'association « Vigilance Crapaud » qui s'agite dans cette pièce et",
    "quelque association existante serait naturellement fortuite, involontaire, et — nous a assuré",
    "notre avocat — rigoureusement improuvable. Quant au crapaud calamite, espèce authentique",
    "et protégée de nos dunes, qu'on se rassure : aucun batracien n'a été consulté sans son accord",
    "durant l'écriture de cette farce.",
    "Les Plaideurs : le juge Dandin et les petits chiens, gravure de Pieter Tanjé, XVIIIe siècle (Rijksmuseum, Amsterdam).",
    "JEAN RACINE (1639-1699)",
    "Jean Racine en 1673 (château de Versailles).",
    "Jean Racine naquit le 22 décembre 1639 à La Ferté-Milon, aux confins du Valois et de la",
    "Picardie. Orphelin de mère à deux ans, de père à quatre, il fut recueilli par sa grand-mère et",
    "instruit gratuitement aux Petites Écoles de Port-Royal, où les jansénistes lui enseignèrent le",
    "grec, le latin et la rigueur — trois choses dont il fit ensuite un usage que ses maîtres n'avaient",
    "pas prévu : le théâtre.",
    "Monté à Paris, il conquit la scène en une décennie prodigieuse : Andromaque (1667) le rendit",
    "célèbre à vingt-sept ans, puis vinrent Britannicus, Bérénice, Bajazet, Mithridate, Iphigénie et Phèdre"
   ]
  },
  {
   "type": "dir",
   "text": "(1677), sommet de la tragédie française. Élu à l'Académie française en 1672, nommé avec"
  },
  {
   "type": "text",
   "text": "Boileau historiographe du roi Louis XIV en 1677, il quitta alors le théâtre et n'y revint que"
  },
  {
   "type": "text",
   "text": "pour Esther et Athalie, écrites pour les demoiselles de Saint-Cyr. Il mourut à Paris le 21 avril"
  },
  {
   "type": "text",
   "text": "1699 et fut enterré, selon son vœu, à Port-Royal, auprès de ses vieux maîtres."
  },
  {
   "type": "text",
   "text": "Et la Normandie, dans tout cela ? Racine était picard de naissance, mais normand de plume."
  },
  {
   "type": "text",
   "text": "Lorsqu'en 1668 il écrivit Les Plaideurs, sa seule comédie, il ne chercha pas longtemps où la"
  },
  {
   "type": "text",
   "text": "situer : « La scène est en une ville de basse Normandie. » C'est que la chicane passait alors"
  },
  {
   "type": "text",
   "text": "pour la seconde nature du Normand : pays de la réponse qui ne dit ni oui ni non, de la"
  },
  {
   "type": "text",
   "text": "coutume la plus subtile du royaume, et des procès qu'on se lègue de père en fils comme un"
  },
  {
   "type": "text",
   "text": "pré ou un pommier. Chicanneau, la Comtesse et le juge Dandin sont donc normands — et"
  },
  {
   "type": "text",
   "text": "l'on jurerait, à les entendre, qu'ils n'ont jamais quitté le pays."
  },
  {
   "type": "text",
   "text": "En ramenant sa farce dans la baie du Mont-Saint-Michel, à deux pas des herbus où l'on"
  },
  {
   "type": "text",
   "text": "plaide encore, son descendant ne l'exile donc pas : il la rapatrie."
  },
  {
   "type": "text",
   "text": "Page de titre de l'édition originale des Plaideurs, chez Claude Barbin, Paris, 1669 (Bibliothèque nationale de France)."
  },
  {
   "type": "speech",
   "speaker": "PERSONNAGES",
   "lines": [
    "Rôle",
    "Emploi"
   ]
  },
  {
   "type": "speech",
   "speaker": "BERTRAND DANDIN",
   "lines": [
    "juge de proximité à la retraite, fou de jugements"
   ]
  },
  {
   "type": "speech",
   "speaker": "LÉANDRE",
   "lines": [
    "fils de Dandin, amoureux d'Isabelle"
   ]
  },
  {
   "type": "speech",
   "speaker": "CHICANEAU",
   "lines": [
    "procédurier, secrétaire perpétuel de Vigilance Crapaud"
   ]
  },
  {
   "type": "speech",
   "speaker": "ISABELLE",
   "lines": [
    "fille de Chicaneau, stagiaire naturaliste",
    "LA COMTESSE DE"
   ]
  },
  {
   "type": "speech",
   "speaker": "PINCEMAILLE",
   "lines": [
    "présidente-fondatrice de Vigilance Crapaud"
   ]
  },
  {
   "type": "speech",
   "speaker": "PETIT-JEAN",
   "lines": [
    "commis de ferme de François"
   ]
  },
  {
   "type": "speech",
   "speaker": "L'INTIMÉ",
   "lines": [
    "homme à tout faire, avocat autoproclamé"
   ]
  },
  {
   "type": "speech",
   "speaker": "FRANÇOIS",
   "lines": [
    "dit le Berger de la baie, éleveur de moutons de prés-",
    "salés"
   ]
  },
  {
   "type": "speech",
   "speaker": "CALAMITE",
   "lines": [
    "crapaud calamite, témoin principal (rôle muet, en",
    "terrarium)",
    "La scène est de nos jours, devant la grande bergerie de bois, au bord des herbus de la baie. Un banc, une brouette, une",
    "échelle contre le pignon. Au troisième acte, une table à tréteaux fera office de tribunal."
   ]
  },
  {
   "type": "act",
   "text": "ACTE PREMIER"
  },
  {
   "type": "scene",
   "text": "Scène 1"
  },
  {
   "type": "text",
   "text": "PETIT-JEAN, seul, poussant une brouette pleine de dossiers."
  },
  {
   "type": "speech",
   "speaker": "PETIT-JEAN",
   "lines": [
    "Ma foi, sur l'avenir bien fou qui se fiera :",
    "Tel qui rit vendredi, dimanche pleurera.",
    "Moi qui gardais jadis trois vaches et deux oies,",
    "Me voilà commis de ferme — et voyez où l'on m'emploie :",
    "Je ne porte plus le foin, je porte des dossiers.",
    "Vingt ans de procédure, et moi seul pour brouetter !",
    "Car voici, bonnes gens, la maison de François,",
    "Le Berger de la baie. Admirez : tout en bois,",
    "Quarante-six mètres quatre-vingt-dix de charpente,",
    "Sur terre battue, comme au Moyen Âge — et sans pente",
    "Fiscale ni béton : du bois, du vent, du sel.",
    "Quatre cents moutons dorment là quand le ciel",
    "Se fâche et que la mer remonte sur l'herbu.",
    "Des moutons de prés-salés, s'il vous plaît : le menu",
    "Le plus couru de France, estampillé, doré :",
    "L'agneau qui broute l'iode a le gigot titré.",
    "Or donc, tout ce bonheur déplut. À qui ? Mystère...",
    "Non : à une association. « Vigilance Crapaud », austère",
    "Vigie de la nature, et de la Manche entière.",
    "Son gibier favori n'est pas le braconnier,",
    "Ni l'usine qui fume, ni le lisier grossier :",
    "Non. C'est mon maître. Un berger. L'ennemi public",
    "Numéro un du crapaud, paraît-il. Le hic,",
    "C'est que le crapaud, lui, n'a jamais porté plainte.",
    "Vingt ans que ça dure ! J'ai la chronologie, peinte",
    "Sur douze mètres de listing — tenez, jugez plutôt :",
    "Deux mille quatre : permis refusé. Aussitôt,",
    "Mon maître abrite ses bêtes sous des tunnels de toile.",
    "Procès-verbal ! Deux mille neuf : il pose la première étoile...",
    "La première poutre. Nouveau procès-verbal ! Deux mille onze,",
    "Miracle : le ministre en personne, dans le bronze",
    "De son bureau parisien, dit : « Régularisez ! »",
    "Le maire signe un permis. Ouf ? Non pas : c'est mal visé,",
    "Dit le tribunal, qui l'annule en douze. En treize, appel :",
    "Confirmé. En quatorze, Conseil d'État : rappel,",
    "Rejeté. Dix-sept : démolition sous deux mois ! Dix-huit :",
    "Confirmée ! Vingt-et-un : astreinte ! Vingt-deux : réduite !",
    "Vingt-quatre : cassation, rejetée ! Et l'automne dernier,",
    "La cour d'appel a dit son dernier mot de greffier :",
    "« Huit mois pour démonter, soixante euros par jour",
    "Ensuite. » Voilà. Vingt ans. Et le compte à rebours.",
    "Le ministre avait dit oui, le tribunal dit non :",
    "En France, il paraît que c'est le tribunal qui a le bon.",
    "Pendant ce temps, mon maître a fait trois mille agneaux,",
    "Trente-cinq mille braves gens ont signé pour sa peau —",
    "Pour la sauver, s'entend — on a fait un film, des fêtes,",
    "Des concerts, des banderoles... et les baudets s'entêtent.",
    "Pardon : les débats. Ma langue fourche quand je m'émeus.",
    "Moi, dans tout ça, je brouette. Et je me dis : sacrebleu,",
    "Si les crapauds savaient tout ce qu'on plaide en leur nom,",
    "Ils déménageraient de honte au fond du limon.",
    "Mais chut ! Voici mon maître. Il a l'œil du matin calme :",
    "C'est l'œil des hommes de mer. L'ouragan, sous la palme."
   ]
  },
  {
   "type": "scene",
   "text": "Scène 2"
  },
  {
   "type": "text",
   "text": "PETIT-JEAN, FRANÇOIS."
  },
  {
   "type": "speech",
   "speaker": "FRANÇOIS",
   "lines": [
    "Petit-Jean, as-tu vu ? La brume s'est levée.",
    "Les prés ont bu la mer, la mer a relavé",
    "L'herbu : c'est un matin à faire honte aux peintures."
   ]
  },
  {
   "type": "speech",
   "speaker": "PETIT-JEAN",
   "lines": [
    "Maître, j'ai vu surtout qu'au bout des écritures,",
    "Il nous reste huit mois. Après quoi, soixante euros",
    "Par jour. Par jour, maître ! De quoi vendre le troupeau",
    "En viande à brochettes avant la Saint-Michel."
   ]
  },
  {
   "type": "speech",
   "speaker": "FRANÇOIS",
   "lines": [
    "Je sais compter, Petit-Jean. Le ciel",
    "M'a donné peu de terre et beaucoup d'arithmétique.",
    "Soixante euros par jour, c'est un loyer de boutique",
    "À Paris. Ici, c'est la peau d'un métier."
   ]
  },
  {
   "type": "speech",
   "speaker": "PETIT-JEAN",
   "lines": [
    "Et vous restez si calme !"
   ]
  },
  {
   "type": "speech",
   "speaker": "FRANÇOIS",
   "lines": [
    "Un berger, c'est l'entier",
    "Contraire d'un plaideur : je regarde la marée.",
    "Elle monte deux fois par jour, jamais pressée,",
    "Et jamais en retard. Elle a tout emporté,",
    "Des empires, des digues... et elle a respecté",
    "Mes moutons, qui la connaissent. Vingt ans de paperasse !",
    "Si j'avais mis vingt ans à mener mes agnasses...",
    "Mes agnelles au pré, la baie serait en friche.",
    "L'herbu, sans la dent du mouton, meurt sous la panicaut riche...",
    "Sous le chiendent, veux-je dire. Un herbu, ça se tond,",
    "Ou ça s'étouffe. Demande aux anciens s'ils ont",
    "Jamais vu la baie propre sans les troupeaux dessus."
   ]
  },
  {
   "type": "speech",
   "speaker": "PETIT-JEAN",
   "lines": [
    "Dites-le au tribunal !"
   ]
  },
  {
   "type": "speech",
   "speaker": "FRANÇOIS",
   "lines": [
    "Je l'ai dit. Ils ont reçu",
    "La chose en pièce jointe. Annexe quarante-trois.",
    "Entre une étude d'impact et un mémoire en droit.",
    "La baie, mon pauvre ami, tient dans un porte-vues."
   ]
  },
  {
   "type": "speech",
   "speaker": "PETIT-JEAN",
   "lines": [
    "Et le crapaud ? Ce fameux crapaud des dunes, l'élu,",
    "Le chouchou, le motif ! L'avez-vous vu, au moins ?"
   ]
  },
  {
   "type": "speech",
   "speaker": "FRANÇOIS",
   "lines": [
    "Le calamite ? Parbleu ! Il loge dans le coin",
    "Le plus doux de la ferme : au chaud, sous l'abreuvoir.",
    "Les mouches des moutons lui font son réfectoire.",
    "C'est le crapaud le mieux nourri du Cotentin.",
    "S'il pouvait témoigner, celui-là, un matin..."
   ]
  },
  {
   "type": "speech",
   "speaker": "PETIT-JEAN",
   "lines": [
    "Un crapaud à la barre ! Et pourquoi non ? On a bien",
    "Mis votre bergerie au banc des assassins.",
    "Attention ! Voilà justement la Vigilance",
    "Qui débarque en side-car. Chicaneau. Sa balance",
    "De poche, son mètre-ruban, son compteur de crapauds.",
    "Cachez les fromages, maître : il compte aussi les cadeaux."
   ]
  },
  {
   "type": "scene",
   "text": "Scène 3"
  },
  {
   "type": "text",
   "text": "Les mêmes, CHICANEAU, harnaché d'appareils de mesure, une sacoche débordant de papiers."
  },
  {
   "type": "speech",
   "speaker": "CHICANEAU",
   "lines": [
    "Constat ! Constat mensuel ! Ne touchez à rien ! Distance !",
    "Article huit du protocole : toute présence",
    "De l'exploitant à moins de dix mètres du constatant",
    "Vaut pression morale et fera l'objet d'un avenant !"
   ]
  },
  {
   "type": "speech",
   "speaker": "FRANÇOIS",
   "lines": [
    "Bonjour, monsieur Chicaneau."
   ]
  },
  {
   "type": "speech",
   "speaker": "CHICANEAU",
   "lines": [
    "Ne me dites pas bonjour !",
    "Un bonjour, c'est un lien ! Un lien, c'est un détour",
    "Vers la corruption ! Notez, je m'auto-notifie :",
    "« Ce jour, l'exploitant a tenté un bonjour. » Je vérifie",
    "Mes instruments. Hygromètre. Décibelmètre. Et le",
    "Crapaudomètre, breveté par mes soins : il compte les",
    "Coassements à l'hectare. Silence ! J'enclenche."
   ]
  },
  {
   "type": "dir",
   "text": "(Silence. L'appareil ne capte rien.)"
  },
  {
   "type": "text",
   "text": "Zéro coassement. C'est un désastre."
  },
  {
   "type": "speech",
   "speaker": "PETIT-JEAN",
   "lines": [
    "C'est un dimanche.",
    "Même le crapaud fait la grasse matinée."
   ]
  },
  {
   "type": "speech",
   "speaker": "CHICANEAU",
   "lines": [
    "Zéro coassement : preuve que la cheminée...",
    "Que la bergerie perturbe l'expression du batracien !"
   ]
  },
  {
   "type": "speech",
   "speaker": "PETIT-JEAN",
   "lines": [
    "Hier, il chantait toute la nuit."
   ]
  },
  {
   "type": "speech",
   "speaker": "CHICANEAU",
   "lines": [
    "Preuve qu'il se plaint !",
    "Coasse-t-il ? Détresse. Se tait-il ? Dépression.",
    "Dans les deux cas : démolition. C'est du droit, ça, mon garçon.",
    "Vingt ans que je le dis : cette cathédrale de planches",
    "Écrase le moral des amphibiens de la Manche."
   ]
  },
  {
   "type": "speech",
   "speaker": "FRANÇOIS",
   "lines": [
    "Il loge sous mon abreuvoir."
   ]
  },
  {
   "type": "speech",
   "speaker": "CHICANEAU",
   "lines": [
    "Syndrome de l'otage !",
    "Il s'attache à son bourreau ! C'est un cas d'école, un stage",
    "Entier là-dessus, j'ai fait : « Stockholm chez les anoures ».",
    "Ce crapaud a besoin d'un psychologue, pas d'amour !"
   ]
  },
  {
   "type": "speech",
   "speaker": "PETIT-JEAN",
   "lines": []
  },
  {
   "type": "dir",
   "text": "(à part)"
  },
  {
   "type": "text",
   "text": "Et moi j'ai besoin d'un calva."
  },
  {
   "type": "speech",
   "speaker": "CHICANEAU",
   "lines": [
    "Je note : « Abreuvoir :",
    "Squat batracien organisé par l'exploitant. Devoir",
    "De signalement. » Et j'ajoute : « Fromages suspects",
    "Dissimulés à l'approche du constatant. » Je sais",
    "Tout, je vois tout ! La tomme n'échappe pas au droit !"
   ]
  },
  {
   "type": "speech",
   "speaker": "FRANÇOIS",
   "lines": [
    "Vous en mangeâtes trois, l'an dernier."
   ]
  },
  {
   "type": "speech",
   "speaker": "CHICANEAU",
   "lines": [
    "C'était des saisies. Trois",
    "Saisies conservatoires. Conservées où je pouvais :",
    "Dans mon estomac. La procédure a ses secrets.",
    "Mais assez causé : où est ma co-plaignante ? Ah ! Madame",
    "La Présidente arrive. Attention : c'est une lame."
   ]
  },
  {
   "type": "scene",
   "text": "Scène 4"
  },
  {
   "type": "text",
   "text": "Les mêmes, LA COMTESSE DE PINCEMAILLE, en cape verte, jumelles au cou."
  },
  {
   "type": "text",
   "text": "LA COMTESSE"
  },
  {
   "type": "text",
   "text": "Ne me parlez pas, je suis en deuil."
  },
  {
   "type": "speech",
   "speaker": "CHICANEAU",
   "lines": [
    "Ciel ! Qui est mort ?",
    "LA COMTESSE",
    "Une haie. À Portbail. Arrachée au bord",
    "D'un champ, mardi, à l'aube, par un tracteur sans âme.",
    "Quarante mètres de prunellier ! J'ai porté plainte, et je réclame",
    "Un deuil départemental. Mais parlons du dossier :",
    "Où en est notre affaire ?"
   ]
  },
  {
   "type": "speech",
   "speaker": "CHICANEAU",
   "lines": [
    "Victoire, madame ! Le greffier",
    "M'a confirmé l'astreinte : soixante euros par jour !",
    "LA COMTESSE",
    "Soixante ? J'avais requis cent cinquante !"
   ]
  },
  {
   "type": "speech",
   "speaker": "CHICANEAU",
   "lines": [
    "Les cours",
    "Rabotent toujours. C'est leur coquetterie.",
    "LA COMTESSE",
    "Raboter !",
    "Voilà le mal français ! On demande une tête,",
    "On vous accorde une mèche ! Enfin. Célébrons. Vingt ans",
    "De combat, mon bon Chicaneau. Vous étiez un enfant",
    "Quand nous assignâmes ce berger la première fois."
   ]
  },
  {
   "type": "speech",
   "speaker": "CHICANEAU",
   "lines": [
    "J'avais cinquante ans, madame.",
    "LA COMTESSE",
    "Un enfant, vous dis-je. Et moi,",
    "J'étais belle à faire annuler un synode.",
    "C'est le contentieux qui conserve. La méthode",
    "Pincemaille : un pourvoi le matin à jeun, un déféré",
    "À cinq heures, et le teint reste frais comme un pré.",
    "Mais dites-moi... ce constat mensuel, il est de vous ?"
   ]
  },
  {
   "type": "speech",
   "speaker": "CHICANEAU",
   "lines": [
    "De ma main.",
    "LA COMTESSE",
    "Il est nul."
   ]
  },
  {
   "type": "speech",
   "speaker": "CHICANEAU",
   "lines": [
    "Plaît-il ?",
    "LA COMTESSE",
    "Nul et non avenu, mon chou.",
    "Vous citez l'article huit : c'est l'article neuf. Vice",
    "De forme. Tout est à refaire."
   ]
  },
  {
   "type": "speech",
   "speaker": "CHICANEAU",
   "lines": [
    "Madame, mon office",
    "Ne souffre aucun contrôle ! Secrétaire perpétuel,",
    "Je suis la mémoire de l'association !",
    "LA COMTESSE",
    "Et moi, le sel !",
    "Présidente-fondatrice ! J'étais crapaud dans l'âme",
    "Quand vous chassiez encore la mouche à l'entame !"
   ]
  },
  {
   "type": "speech",
   "speaker": "CHICANEAU",
   "lines": [
    "Retirez « l'entame » !",
    "LA COMTESSE",
    "Je maintiens « l'entame » !"
   ]
  },
  {
   "type": "speech",
   "speaker": "CHICANEAU",
   "lines": [
    "Outrage",
    "À secrétaire en exercice ! Témoins ! Constat ! Page",
    "Trente du règlement intérieur : la présidente me doit",
    "Le respect dû aux archives !",
    "LA COMTESSE",
    "Le règlement ? C'est moi qui l'écrivis, du doigt",
    "Gauche, un soir de fondation ! Je vous révoque !"
   ]
  },
  {
   "type": "speech",
   "speaker": "CHICANEAU",
   "lines": [
    "Je vous destitue ! Assemblée générale ad hoc !",
    "Motion ! Quorum ! J'ai la liste des adhérents !",
    "LA COMTESSE",
    "Ils sont deux : vous et moi !"
   ]
  },
  {
   "type": "speech",
   "speaker": "CHICANEAU",
   "lines": [
    "Le quorum est atteint, tourment !",
    "Je m'élis président !",
    "LA COMTESSE",
    "Je m'élis présidente !"
   ]
  },
  {
   "type": "speech",
   "speaker": "CHICANEAU",
   "lines": [
    "Procès !",
    "LA COMTESSE",
    "Procès !"
   ]
  },
  {
   "type": "speech",
   "speaker": "CHICANEAU",
   "lines": [
    "Procès !",
    "LA COMTESSE",
    "Procès !"
   ]
  },
  {
   "type": "speech",
   "speaker": "PETIT-JEAN",
   "lines": []
  },
  {
   "type": "dir",
   "text": "(à François)"
  },
  {
   "type": "text",
   "text": "Ils s'aiment, ces deux-là. Ça crève les yeux. C'est"
  },
  {
   "type": "text",
   "text": "Leur manière de se dire des douceurs : l'assignation,"
  },
  {
   "type": "text",
   "text": "Chez eux, remplace le bouquet. Attention ! Attention !"
  },
  {
   "type": "text",
   "text": "Là-haut ! Sur le toit de la bergerie ! Un homme en robe !"
  },
  {
   "type": "speech",
   "speaker": "FRANÇOIS",
   "lines": [
    "En robe de chambre ?"
   ]
  },
  {
   "type": "speech",
   "speaker": "PETIT-JEAN",
   "lines": [
    "En robe de juge ! Le ciel nous gobe !"
   ]
  },
  {
   "type": "scene",
   "text": "Scène 5"
  },
  {
   "type": "text",
   "text": "Les mêmes, DANDIN, apparaissant au faîte de la bergerie, en robe noire par-dessus un pyjama ; puis"
  },
  {
   "type": "text",
   "text": "LÉANDRE, accourant."
  },
  {
   "type": "speech",
   "speaker": "DANDIN",
   "lines": [
    "J'ai tout entendu ! Quelle affaire ! Quel gisement !",
    "Vingt ans de procédure ! Un crapaud ! Un aliment",
    "Pareil, et nul ne m'en disait rien ! Greffier ! Audience !"
   ]
  },
  {
   "type": "speech",
   "speaker": "FRANÇOIS",
   "lines": [
    "Qui est ce monsieur sur ma charpente ?"
   ]
  },
  {
   "type": "speech",
   "speaker": "PETIT-JEAN",
   "lines": [
    "Une connaissance :",
    "Bertrand Dandin, le juge retraité du bourg. Il fugue",
    "Chaque fois qu'il flaire un litige. Sa toque lui sert de fugue...",
    "De fusée, veux-je dire. Descendez, monsieur Dandin !"
   ]
  },
  {
   "type": "speech",
   "speaker": "DANDIN",
   "lines": [
    "Un juge est toujours au-dessus des parties ! J'ai le coup d'œil plein :",
    "D'ici je vois tout : la bergerie, l'herbu, la Manche,",
    "Et deux plaideurs en bas, mûrs comme poires en branche !"
   ]
  },
  {
   "type": "dir",
   "text": "(Entre LÉANDRE, essoufflé.)"
  },
  {
   "type": "speech",
   "speaker": "LÉANDRE",
   "lines": [
    "Mon père ! Encore ! Trois kilomètres en pantoufles !",
    "Descendez !"
   ]
  },
  {
   "type": "speech",
   "speaker": "DANDIN",
   "lines": [
    "Jamais ! J'instruis !"
   ]
  },
  {
   "type": "speech",
   "speaker": "LÉANDRE",
   "lines": [
    "Vous m'essoufflez !"
   ]
  },
  {
   "type": "speech",
   "speaker": "DANDIN",
   "lines": [
    "Je souffle",
    "Où souffle le droit ! Fils, écoute-moi bien :",
    "Il y a ici même une affaire — un festin ! —",
    "Que la justice de Caen, de Nantes et de Paris",
    "A jugée vingt fois sans que nul n'en ait ri",
    "Ni pleuré content. Tous mécontents ! Le berger : perdu",
    "Sa bergerie. L'association : attendu",
    "Vingt ans. Le crapaud : jamais entendu ! Le ministre :",
    "Désavoué ! Le maire : annulé ! Un tel sinistre",
    "Judiciaire, ça se rejuge, et céans !"
   ]
  },
  {
   "type": "speech",
   "speaker": "CHICANEAU",
   "lines": []
  },
  {
   "type": "dir",
   "text": "(intéressé)"
  },
  {
   "type": "text",
   "text": "Rejuger ? Est-ce bien légal ?"
  },
  {
   "type": "speech",
   "speaker": "DANDIN",
   "lines": [
    "Nullement ! C'est mieux : c'est séant !",
    "Je fonde à l'instant le Tribunal des Herbus,",
    "Juridiction souveraine des choses qu'on n'a pas entendues !",
    "Sans appel, sans pourvoi, sans frais !"
   ]
  },
  {
   "type": "speech",
   "speaker": "CHICANEAU",
   "lines": [
    "Sans frais ? Quel dommage..."
   ]
  },
  {
   "type": "speech",
   "speaker": "DANDIN",
   "lines": [
    "J'ajouterai des frais symboliques."
   ]
  },
  {
   "type": "speech",
   "speaker": "CHICANEAU",
   "lines": [
    "J'en suis ! Hommage !",
    "LA COMTESSE",
    "Un tribunal de plus ? Où l'on plaide ? J'apporte",
    "Ma jurisprudence personnelle : quarante ans, en quatre cartes",
    "Mémoire !"
   ]
  },
  {
   "type": "speech",
   "speaker": "LÉANDRE",
   "lines": [
    "Père, c'est une folie !"
   ]
  },
  {
   "type": "speech",
   "speaker": "DANDIN",
   "lines": [
    "Non, fils : une thérapie.",
    "Et peut-être — qui sait ? — la seule fois de ma vie",
    "Où juger servira. Demain, dix heures, céans :",
    "Le procès de la bergerie ! Qu'on cite les géants :",
    "La partie civile ! La défense ! Le crapaud !",
    "Et qu'on m'apporte ma casserole en guise de marteau !"
   ]
  },
  {
   "type": "speech",
   "speaker": "PETIT-JEAN",
   "lines": []
  },
  {
   "type": "dir",
   "text": "(au public)"
  },
  {
   "type": "text",
   "text": "Voilà. C'est parti. Priez pour nous, bonnes gens d'Avranches :"
  },
  {
   "type": "text",
   "text": "Quand la justice déraille, c'est ici qu'elle se branche."
  },
  {
   "type": "dir",
   "text": "(Noir.)"
  },
  {
   "type": "act",
   "text": "ACTE II"
  },
  {
   "type": "scene",
   "text": "Scène 1"
  },
  {
   "type": "text",
   "text": "LÉANDRE, L'INTIMÉ."
  },
  {
   "type": "speech",
   "speaker": "LÉANDRE",
   "lines": [
    "L'Intimé, mon ami, j'ai besoin de tes talents."
   ]
  },
  {
   "type": "speech",
   "speaker": "L'INTIMÉ",
   "lines": [
    "Lesquels ? J'en ai plusieurs, tous approximativement."
   ]
  },
  {
   "type": "speech",
   "speaker": "LÉANDRE",
   "lines": [
    "Isabelle. La fille de Chicaneau. La stagiaire",
    "Naturaliste qui recense les mares et les rainettes... Hier",
    "Encore, je l'ai vue sur la dune, à plat ventre,",
    "Comptant les calamites au crépuscule. Mon cœur, contre",
    "Toute prudence, s'est couché dans le sable à côté."
   ]
  },
  {
   "type": "speech",
   "speaker": "L'INTIMÉ",
   "lines": [
    "Vous comptiez les crapauds ?"
   ]
  },
  {
   "type": "speech",
   "speaker": "LÉANDRE",
   "lines": [
    "Je la comptais, elle. En entier. L'été",
    "Lui va comme un permis de construire en zone libre.",
    "Mais son père me hait : je suis fils de ce juge, cette fibre",
    "Lui déplaît — Dandin l'a débouté jadis trois fois.",
    "Il garde sa fille comme un original : sous clé, et froid.",
    "Il faut que je lui parle. Or nul n'entre chez Chicaneau",
    "Sans papier timbré. Un seul homme passe l'anneau :",
    "Un huissier."
   ]
  },
  {
   "type": "speech",
   "speaker": "L'INTIMÉ",
   "lines": [
    "Mon rêve après le barreau ! Le costume est facile :",
    "Cravate grise, serviette, et cette mine hostile",
    "Des hommes que la loi paie pour sonner deux fois."
   ]
  },
  {
   "type": "speech",
   "speaker": "LÉANDRE",
   "lines": [
    "Tu lui remettras cet acte. Regarde-le bien."
   ]
  },
  {
   "type": "speech",
   "speaker": "L'INTIMÉ",
   "lines": [
    "Je vois...",
    "« Sommation... de répondre à l'amour du requérant...",
    "Ledit cœur, ci-après dénommé le brûlant... »",
    "Mais c'est une demande en mariage en bon droit !"
   ]
  },
  {
   "type": "speech",
   "speaker": "LÉANDRE",
   "lines": [
    "Rédigée en termes d'huissier : son père y verra",
    "Du papier officiel. Il signera même",
    "La copie sans la lire — il signe tout, il aime",
    "L'encre. Et sur ce papier, en petits caractères..."
   ]
  },
  {
   "type": "speech",
   "speaker": "L'INTIMÉ",
   "lines": [
    "« Le soussigné consent au mariage. » Ah, le mystère",
    "S'éclaire ! Vous piégez le vieux par sa manie !"
   ]
  },
  {
   "type": "speech",
   "speaker": "LÉANDRE",
   "lines": [
    "Chacun sa jurisprudence. L'amour aussi",
    "A ses voies d'exécution."
   ]
  },
  {
   "type": "speech",
   "speaker": "L'INTIMÉ",
   "lines": [
    "C'est fourbe, c'est vil, c'est bas...",
    "J'en suis. Passez-moi la cravate. On ne dira pas",
    "Que l'Intimé recula devant une audience."
   ]
  },
  {
   "type": "speech",
   "speaker": "LÉANDRE",
   "lines": [
    "File. Et surtout, pas de zèle : de la vraisemblance."
   ]
  },
  {
   "type": "scene",
   "text": "Scène 2"
  },
  {
   "type": "text",
   "text": "Devant la maison de Chicaneau. ISABELLE, un carnet de terrain à la main ; L'INTIMÉ, en huissier."
  },
  {
   "type": "speech",
   "speaker": "ISABELLE",
   "lines": [
    "Encore un huissier ! Trois par semaine ! Ça défile",
    "Plus que chez le boulanger. Posez là, sur la pile.",
    "Mon père est sorti poster dix-huit recommandés."
   ]
  },
  {
   "type": "speech",
   "speaker": "L'INTIMÉ",
   "lines": []
  },
  {
   "type": "dir",
   "text": "(solennel)"
  },
  {
   "type": "text",
   "text": "Mademoiselle, c'est à vous que je dois demander"
  },
  {
   "type": "text",
   "text": "Audience : j'ai un acte à vous remettre en mains propres."
  },
  {
   "type": "speech",
   "speaker": "ISABELLE",
   "lines": [
    "À moi ? Un exploit pour moi ? Papa sera jaloux. Après",
    "Tout, il était temps : vingt-trois ans et pas une assignation,",
    "Il me croyait ratée. Tiens... Cette rédaction...",
    "Cette boucle au « L »... Je connais cette écriture..."
   ]
  },
  {
   "type": "dir",
   "text": "(Elle lit, rougit.)"
  },
  {
   "type": "text",
   "text": "Ah !"
  },
  {
   "type": "speech",
   "speaker": "L'INTIMÉ",
   "lines": [
    "Chut ! Lisez tout bas ; les murs plaident, c'est leur nature."
   ]
  },
  {
   "type": "speech",
   "speaker": "ISABELLE",
   "lines": []
  },
  {
   "type": "dir",
   "text": "(lisant)"
  },
  {
   "type": "text",
   "text": "« Sommation d'aimer... le requérant Léandre... »"
  },
  {
   "type": "text",
   "text": "Le fou ! L'adorable fou ! Se déclarer en papier tendre"
  },
  {
   "type": "text",
   "text": "Déguisé en papier bleu ! Et il requiert quoi ?"
  },
  {
   "type": "text",
   "text": "« ... réponse par retour, sous astreinte d'un baiser par mois"
  },
  {
   "type": "text",
   "text": "De retard... » L'usurier ! J'accepte tous les intérêts."
  },
  {
   "type": "text",
   "text": "Dites-lui... Non, écrivez, soyons dans les formes, s'il vous plaît :"
  },
  {
   "type": "text",
   "text": "« La défenderesse » — c'est moi — « reconnaît sa dette,"
  },
  {
   "type": "text",
   "text": "Et s'avoue insolvable en tendresse : elle s'endette"
  },
  {
   "type": "text",
   "text": "Pour la vie. » Signé : Isabelle. Et j'ajoute un post-scriptum :"
  },
  {
   "type": "text",
   "text": "« La défenderesse fait observer, pour le quorum,"
  },
  {
   "type": "text",
   "text": "Que le crapaud calamite prospère près des bergeries :"
  },
  {
   "type": "text",
   "text": "Elle en tient le relevé, preuves à l'appui, et prie"
  },
  {
   "type": "text",
   "text": "Le requérant de la citer comme expert. » Voilà."
  },
  {
   "type": "speech",
   "speaker": "L'INTIMÉ",
   "lines": [
    "Un post-scriptum scientifique dans un acte d'amour ! On aura",
    "Tout vu. Vous êtes bien la fille de votre père."
   ]
  },
  {
   "type": "speech",
   "speaker": "ISABELLE",
   "lines": [
    "Détrompez-vous : lui plaide pour plaider ; moi, pour la terre.",
    "Il aime la procédure, j'aime les mares. Chacun ses eaux.",
    "Le drame de papa, voyez-vous, c'est qu'aucun crapaud",
    "N'a jamais eu besoin de lui. Attention ! Le voilà !",
    "Composez-vous. Gonflez la serviette. Et surtout : pas",
    "De parfum sur les actes, il a le nez du métier."
   ]
  },
  {
   "type": "scene",
   "text": "Scène 3"
  },
  {
   "type": "text",
   "text": "Les mêmes, CHICANEAU."
  },
  {
   "type": "speech",
   "speaker": "CHICANEAU",
   "lines": [
    "Un huissier ? Chez moi ? Sans rendez-vous ? Quel est ce monstre",
    "D'irrégularité ? Montrez votre médaille, votre ordre,",
    "Votre carte, vos diplômes, votre extrait de naissance !"
   ]
  },
  {
   "type": "speech",
   "speaker": "L'INTIMÉ",
   "lines": []
  },
  {
   "type": "dir",
   "text": "(à part)"
  },
  {
   "type": "text",
   "text": "Diable. (Haut.) Monsieur, la loi m'exempte de complaisance :"
  },
  {
   "type": "text",
   "text": "Huissier audiencier près la baie et dépendances,"
  },
  {
   "type": "text",
   "text": "Commis à la remise d'actes de conséquence."
  },
  {
   "type": "speech",
   "speaker": "CHICANEAU",
   "lines": [
    "D'actes ? Quels actes ? J'attaque, on m'attaque ? Bonheur !",
    "De qui ? Combien ? Où ça ? Donnez, donnez, j'ai l'heure",
    "Exacte à consigner : quinze heures dix. Signature !",
    "Où signé-je ?"
   ]
  },
  {
   "type": "speech",
   "speaker": "L'INTIMÉ",
   "lines": [
    "Ici. Et là. Et là. Paraphe. Rature —",
    "Non, ne raturez pas ! Là, l'original. C'est fait."
   ]
  },
  {
   "type": "speech",
   "speaker": "CHICANEAU",
   "lines": []
  },
  {
   "type": "dir",
   "text": "(reniflant les papiers)"
  },
  {
   "type": "text",
   "text": "Attendez... Ce papier sent la rose. Un acte qui fleure"
  },
  {
   "type": "text",
   "text": "Le parfum ? Montrez voir cette copie..."
  },
  {
   "type": "speech",
   "speaker": "L'INTIMÉ",
   "lines": []
  },
  {
   "type": "dir",
   "text": "(reculant)"
  },
  {
   "type": "text",
   "text": "Monsieur, l'odeur"
  },
  {
   "type": "text",
   "text": "Est réglementaire : essence de greffe, article neuf."
  },
  {
   "type": "speech",
   "speaker": "CHICANEAU",
   "lines": [
    "Article neuf ? De quel code ?"
   ]
  },
  {
   "type": "speech",
   "speaker": "L'INTIMÉ",
   "lines": [
    "Du code... du code neuf.",
    "Tout nouveau. Réforme de l'an dernier. Décret d'application",
    "Différé."
   ]
  },
  {
   "type": "speech",
   "speaker": "CHICANEAU",
   "lines": [
    "Vous mentez ! Un huissier qui sent la contrefaçon !",
    "Je vous soufflette, monsieur, pour voir vos vrais papiers !"
   ]
  },
  {
   "type": "dir",
   "text": "(Il le gifle.)"
  },
  {
   "type": "speech",
   "speaker": "L'INTIMÉ",
   "lines": []
  },
  {
   "type": "dir",
   "text": "(radieux)"
  },
  {
   "type": "text",
   "text": "Une gifle ! Une vraie ! Sur huissier assermenté !"
  },
  {
   "type": "text",
   "text": "Recommencez, monsieur, je vous prie : sans témoin"
  },
  {
   "type": "text",
   "text": "Elle ne vaut rien !"
  },
  {
   "type": "speech",
   "speaker": "CHICANEAU",
   "lines": [
    "Plaît-il ?"
   ]
  },
  {
   "type": "speech",
   "speaker": "L'INTIMÉ",
   "lines": [
    "Isabelle est trop loin,",
    "Et regardait ailleurs. Refrappez-moi la même,",
    "Bien claquante, à main plate : au tarif du barème,",
    "Voies de fait sur ministériel : mille euros. Allez,",
    "Un petit effort : l'autre joue est toute neuve. Frappez !"
   ]
  },
  {
   "type": "speech",
   "speaker": "CHICANEAU",
   "lines": []
  },
  {
   "type": "dir",
   "text": "(méfiant)"
  },
  {
   "type": "text",
   "text": "Mille euros la gifle ?"
  },
  {
   "type": "speech",
   "speaker": "L'INTIMÉ",
   "lines": [
    "Et le pied aux fesses, deux mille.",
    "C'est indexé."
   ]
  },
  {
   "type": "speech",
   "speaker": "CHICANEAU",
   "lines": []
  },
  {
   "type": "dir",
   "text": "(rangeant sa main)"
  },
  {
   "type": "text",
   "text": "Non, non. Je connais la file"
  },
  {
   "type": "text",
   "text": "Des jurisprudences. Vous n'aurez rien. Toutefois, notez"
  },
  {
   "type": "text",
   "text": "Que l'intention y était : ça doit bien coûter"
  },
  {
   "type": "text",
   "text": "Cinquante euros, l'intention ?"
  },
  {
   "type": "speech",
   "speaker": "L'INTIMÉ",
   "lines": []
  },
  {
   "type": "dir",
   "text": "(à part)"
  },
  {
   "type": "text",
   "text": "Je tiens mon caractère :"
  },
  {
   "type": "text",
   "text": "Il marchande ses gifles. (Haut.) Monsieur, l'affaire"
  },
  {
   "type": "text",
   "text": "S'arrangera. J'ai vos signatures : mission remplie."
  },
  {
   "type": "text",
   "text": "Serviteur !"
  },
  {
   "type": "dir",
   "text": "(Il s'enfuit.)"
  },
  {
   "type": "speech",
   "speaker": "CHICANEAU",
   "lines": []
  },
  {
   "type": "dir",
   "text": "(dépliant sa copie)"
  },
  {
   "type": "text",
   "text": "Voyons ce que j'ai signé... « Consent... mariage... »"
  },
  {
   "type": "text",
   "text": "MARIAGE ? ISABELLE ! Qu'est-ce que ce carnage ?"
  },
  {
   "type": "speech",
   "speaker": "ISABELLE",
   "lines": []
  },
  {
   "type": "dir",
   "text": "(faussement candide)"
  },
  {
   "type": "text",
   "text": "Vous avez signé, père. En trois exemplaires."
  },
  {
   "type": "text",
   "text": "Et vous m'avez toujours dit : « Ma fille, en toute affaire,"
  },
  {
   "type": "text",
   "text": "La signature est reine et le signataire, sujet. »"
  },
  {
   "type": "speech",
   "speaker": "CHICANEAU",
   "lines": [
    "Je... tu... il... Nous irons en justice !"
   ]
  },
  {
   "type": "speech",
   "speaker": "ISABELLE",
   "lines": []
  },
  {
   "type": "dir",
   "text": "(ravie)"
  },
  {
   "type": "text",
   "text": "Quel beau projet."
  },
  {
   "type": "text",
   "text": "Vous attaquerez votre gendre : ainsi, tout reste en famille."
  },
  {
   "type": "speech",
   "speaker": "CHICANEAU",
   "lines": []
  },
  {
   "type": "dir",
   "text": "(effondré sur une chaise)"
  },
  {
   "type": "text",
   "text": "Piégé... moi... par un acte... La chose me torpille"
  },
  {
   "type": "text",
   "text": "Et me flatte à la fois. Quel travail ! Quelle forme !"
  },
  {
   "type": "text",
   "text": "Ce jeune homme a du droit. Mon Dieu, tout se déforme :"
  },
  {
   "type": "text",
   "text": "Je hais son père et j'admire sa procédure..."
  },
  {
   "type": "text",
   "text": "Il me faut plaider quelque chose, vite, ou l'âme me dure..."
  },
  {
   "type": "text",
   "text": "Le procès de demain ! La bergerie ! L'audience m'appelle !"
  },
  {
   "type": "text",
   "text": "Je réclame le rôle de l'accusation ! C'est le plus bel"
  },
  {
   "type": "text",
   "text": "Emploi de ma carrière ! Isabelle, repasse ma cravate :"
  },
  {
   "type": "text",
   "text": "Demain, ton père plaide, et la baie se mate..."
  },
  {
   "type": "text",
   "text": "Se met, veux-je dire, à l'heure de la Justice !"
  },
  {
   "type": "speech",
   "speaker": "ISABELLE",
   "lines": []
  },
  {
   "type": "dir",
   "text": "(au public)"
  },
  {
   "type": "text",
   "text": "Il est incorrigible. Mais demain, à l'exercice,"
  },
  {
   "type": "text",
   "text": "Il y aura aussi une experte, et un crapaud :"
  },
  {
   "type": "text",
   "text": "Nous verrons bien qui des deux fera le plus beau."
  },
  {
   "type": "scene",
   "text": "Scène 4"
  },
  {
   "type": "text",
   "text": "La cour de Dandin. DANDIN descend le long de la gouttière, en robe. PETIT-JEAN accourt. Puis"
  },
  {
   "type": "text",
   "text": "CHICANEAU et LA COMTESSE, chacun d'un côté."
  },
  {
   "type": "speech",
   "speaker": "PETIT-JEAN",
   "lines": [
    "Monsieur ! La gouttière ! Elle a cent ans, comme vous !"
   ]
  },
  {
   "type": "speech",
   "speaker": "DANDIN",
   "lines": [
    "Silence, greffier ! Le juge descend vers ses fous...",
    "Vers ses justiciables ! J'ai entendu, par le vent porté,",
    "Le mot le plus doux de la langue : « référé ». Fouetté",
    "Par ce mot, je descends siéger. Où est ma casserole ?"
   ]
  },
  {
   "type": "speech",
   "speaker": "PETIT-JEAN",
   "lines": [
    "Au propre. Elle avait jugé trop de soles",
    "Hier midi."
   ]
  },
  {
   "type": "dir",
   "text": "(Entrent en trombe CHICANEAU et LA COMTESSE.)"
  },
  {
   "type": "speech",
   "speaker": "CHICANEAU",
   "lines": [
    "Monsieur le juge, à moi ! Cette femme m'a traité de mèche",
    "À l'entame, et destitué sans quorum véritable !",
    "LA COMTESSE",
    "Monsieur le juge, à moi ! Cet homme s'est auto-élu président de table",
    "Sans consulter la fondatrice, et devant témoins m'a manqué !"
   ]
  },
  {
   "type": "speech",
   "speaker": "CHICANEAU",
   "lines": [
    "J'ai l'enregistrement !",
    "LA COMTESSE",
    "J'ai les statuts annotés !"
   ]
  },
  {
   "type": "speech",
   "speaker": "CHICANEAU",
   "lines": [
    "J'ai un témoin auriculaire !",
    "LA COMTESSE",
    "J'ai un témoin oculaire, ET ses lunettes !"
   ]
  },
  {
   "type": "speech",
   "speaker": "DANDIN",
   "lines": []
  },
  {
   "type": "dir",
   "text": "(aux anges)"
  },
  {
   "type": "text",
   "text": "Doucement, mes agneaux ! Chacun son tour de crier."
  },
  {
   "type": "text",
   "text": "Deux parties, un dimanche ! Je devrais me faire payer"
  },
  {
   "type": "text",
   "text": "En jours pareils. Asseyez-vous. Levez-vous. Rasseyez-vous. La forme"
  },
  {
   "type": "text",
   "text": "Avant tout. Bien. J'écoute. Et que nul ne s'endorme."
  },
  {
   "type": "text",
   "text": "Madame, exposez."
  },
  {
   "type": "text",
   "text": "LA COMTESSE"
  },
  {
   "type": "text",
   "text": "Monsieur le juge, tout commença en mil neuf cent quatre-vingt-six,"
  },
  {
   "type": "text",
   "text": "Quand feu mon mari, le Comte, planta un tamaris..."
  },
  {
   "type": "speech",
   "speaker": "DANDIN",
   "lines": [
    "Le tamaris, passons. Venez à la dispute.",
    "LA COMTESSE",
    "J'y viens ! Mais il faut remonter d'abord à ma grand-tante,",
    "Qui la première adhéra à une société savante,",
    "En mil neuf cent soixante, contre l'avis d'un notaire..."
   ]
  },
  {
   "type": "speech",
   "speaker": "DANDIN",
   "lines": [
    "Passez au déluge, madame !",
    "LA COMTESSE",
    "Le déluge ? Il est postérieur à mon affaire !"
   ]
  },
  {
   "type": "speech",
   "speaker": "DANDIN",
   "lines": []
  },
  {
   "type": "dir",
   "text": "(à part)"
  },
  {
   "type": "text",
   "text": "Elle est plus forte que moi. (Haut.) Monsieur, vous, exposez !"
  },
  {
   "type": "speech",
   "speaker": "CHICANEAU",
   "lines": []
  },
  {
   "type": "dir",
   "text": "(déballant vingt classeurs)"
  },
  {
   "type": "text",
   "text": "Volontiers ! Pièce une : les statuts. Pièce deux : les statuts annotés."
  },
  {
   "type": "text",
   "text": "Pièce trois : mes annotations sur les annotations..."
  },
  {
   "type": "speech",
   "speaker": "DANDIN",
   "lines": []
  },
  {
   "type": "dir",
   "text": "(ravi, à part)"
  },
  {
   "type": "text",
   "text": "Quel style ! Quelle abondance ! Si je m'écoutais, la session"
  },
  {
   "type": "text",
   "text": "Durerait jusqu'à Noël... Mais j'ai promis à mon fils"
  },
  {
   "type": "text",
   "text": "De garder mon audience pour demain. Sacrifice !"
  },
  {
   "type": "dir",
   "text": "(Haut.)"
  },
  {
   "type": "text",
   "text": "La Cour, statuant en la forme des référés d'urgence,"
  },
  {
   "type": "text",
   "text": "Renvoie la querelle de l'association à l'audience"
  },
  {
   "type": "text",
   "text": "De demain, toutes affaires jointes ! Ainsi, d'un seul marteau,"
  },
  {
   "type": "text",
   "text": "Je jugerai le berger, la bergerie, le crapaud,"
  },
  {
   "type": "text",
   "text": "La présidente, le secrétaire, et l'entame, et la mèche !"
  },
  {
   "type": "text",
   "text": "L'économie de moyens, voilà ma marque fraîche !"
  },
  {
   "type": "speech",
   "speaker": "CHICANEAU",
   "lines": []
  },
  {
   "type": "dir",
   "text": "(ébloui)"
  },
  {
   "type": "text",
   "text": "Joindre les instances... Ce juge est un poète."
  },
  {
   "type": "text",
   "text": "LA COMTESSE"
  },
  {
   "type": "text",
   "text": "Pour une fois, l'ancien monde a du neuf dans la tête."
  },
  {
   "type": "text",
   "text": "À demain, monsieur le secrétaire déchu."
  },
  {
   "type": "speech",
   "speaker": "CHICANEAU",
   "lines": [
    "À demain, madame la présidente sursitaire. Et pointu,",
    "Mon dossier vous attend.",
    "LA COMTESSE",
    "Le mien vous dévore."
   ]
  },
  {
   "type": "speech",
   "speaker": "PETIT-JEAN",
   "lines": []
  },
  {
   "type": "dir",
   "text": "(à part)"
  },
  {
   "type": "text",
   "text": "Si l'amour a un greffe, ces deux-là s'y adorent."
  },
  {
   "type": "scene",
   "text": "Scène 5"
  },
  {
   "type": "text",
   "text": "DANDIN, LÉANDRE."
  },
  {
   "type": "speech",
   "speaker": "LÉANDRE",
   "lines": [
    "Un procès ? Vous ? Demain ? Père, encore ! C'est de la démence !"
   ]
  },
  {
   "type": "speech",
   "speaker": "DANDIN",
   "lines": [
    "Non pas : de la clémence. Écoute, fils, et pense :",
    "Ton père fut un juge, et un juge jugeant.",
    "Ôte l'eau au poisson, à l'avare l'argent,",
    "Au berger ses moutons, au juge son audience :",
    "Que reste-t-il ? Un mort qui fait de la présence.",
    "Et puis cette affaire-ci n'est pas comme les autres cas :",
    "Vingt ans de vraie justice y ont usé leurs bras",
    "Sans contenter personne. Les jugements sont rendus —",
    "Qui suis-je pour les défaire ? Personne. Un vieux perdu",
    "En pantoufles. Mais il manque à ce dossier une chose",
    "Que nul tribunal n'a fournie : une pause. Une glose.",
    "Un lieu où chacun parle et où quelqu'un écoute.",
    "Mon tribunal ne peut rien casser, rien mettre en déroute :",
    "Il peut juste entendre. C'est peu. C'est immense. Aide-moi."
   ]
  },
  {
   "type": "speech",
   "speaker": "LÉANDRE",
   "lines": []
  },
  {
   "type": "dir",
   "text": "(à part)"
  },
  {
   "type": "text",
   "text": "Le fait est qu'il va mieux depuis qu'il a cet emploi..."
  },
  {
   "type": "text",
   "text": "Et puis Isabelle y sera experte... et son père"
  },
  {
   "type": "text",
   "text": "Doit y signer devant témoins un acte très sincère..."
  },
  {
   "type": "dir",
   "text": "(Haut.)"
  },
  {
   "type": "text",
   "text": "Soit. Une seule audience, et après, la tisane ?"
  },
  {
   "type": "speech",
   "speaker": "DANDIN",
   "lines": [
    "Parole de magistrat : après le crapaud... les mots croisés. Et les ânes",
    "Du voisin, que je ne jugerai plus, promis, même s'ils braient",
    "En délibéré. File préparer la salle ! Et qu'on m'étraie...",
    "Qu'on m'étrenne une casserole neuve ! La Cour, demain, sonne",
    "Son dernier procès — et le premier où personne",
    "Ne paiera d'avocat, de timbre ni d'expert :",
    "La justice, une fois, sera comme la mer :",
    "Gratuite, ponctuelle, et pleine de moutons."
   ]
  },
  {
   "type": "dir",
   "text": "(Noir.)"
  },
  {
   "type": "act",
   "text": "ACTE III"
  },
  {
   "type": "scene",
   "text": "Scène 1"
  },
  {
   "type": "text",
   "text": "Devant la bergerie, transformée en prétoire champêtre : table à tréteaux, chaise haute, une barre faite d'une houlette"
  },
  {
   "type": "text",
   "text": "posée sur deux bottes de paille. PETIT-JEAN en greffier (lunettes sans verres), L'INTIMÉ en robe (un rideau"
  },
  {
   "type": "text",
   "text": "cousu, les anneaux encore visibles)."
  },
  {
   "type": "speech",
   "speaker": "PETIT-JEAN",
   "lines": [
    "Comment me trouves-tu ?"
   ]
  },
  {
   "type": "speech",
   "speaker": "L'INTIMÉ",
   "lines": [
    "Terrifiant. On dirait",
    "Un corbeau qui aurait avalé un notaire. Et moi ?"
   ]
  },
  {
   "type": "speech",
   "speaker": "PETIT-JEAN",
   "lines": [
    "Prêt",
    "À plaider. Le rideau te va comme un gant.",
    "On voit encore les anneaux."
   ]
  },
  {
   "type": "speech",
   "speaker": "L'INTIMÉ",
   "lines": [
    "C'est mon côté élégant :",
    "Si je perds le procès, je peux me tirer... sur tringle.",
    "Mais je ne perdrai pas : j'ai un dossier qui épingle,",
    "Un témoin qui coasse et une experte qui sait.",
    "Et toi, greffier, ta plume ?"
   ]
  },
  {
   "type": "speech",
   "speaker": "PETIT-JEAN",
   "lines": [
    "Un crayon de charpentier. C'est",
    "Tout ce qu'on avait. Il écrit gras, mais il écrit juste :",
    "C'est le crayon qui a tracé la bergerie. Auguste",
    "Relique ! S'il faut noter sa mort, autant que ce soit lui...",
    "J'ai le trac, l'Intimé. Il y aura du monde, aujourd'hui :",
    "Tout le canton, deux journalistes, un car de Bretons."
   ]
  },
  {
   "type": "speech",
   "speaker": "L'INTIMÉ",
   "lines": [
    "Fais comme moi : imagine le public en moutons.",
    "Chut ! La Cour ! Debout ! Et cache les fromages sous le greffe."
   ]
  },
  {
   "type": "scene",
   "text": "Scène 2"
  },
  {
   "type": "text",
   "text": "Tous. DANDIN siège, casserole neuve en guise de marteau. CHICANEAU, en cravate repassée, côté accusation,"
  },
  {
   "type": "text",
   "text": "LA COMTESSE à ses côtés. FRANÇOIS, ISABELLE, LÉANDRE. Sur la table, un terrarium :"
  },
  {
   "type": "text",
   "text": "CALAMITE, crapaud, témoin."
  },
  {
   "type": "speech",
   "speaker": "DANDIN",
   "lines": []
  },
  {
   "type": "dir",
   "text": "(frappant la casserole)"
  },
  {
   "type": "text",
   "text": "L'audience du Tribunal des Herbus est ouverte !"
  },
  {
   "type": "text",
   "text": "Affaire : Vigilance Crapaud contre une couverte..."
  },
  {
   "type": "text",
   "text": "Une couverture de bois de neuf cent quatre-vingts mètres carrés,"
  },
  {
   "type": "text",
   "text": "Dite « la bergerie ». L'accusée, levez-vous !"
  },
  {
   "type": "dir",
   "text": "(Silence. La bergerie ne bouge pas.)"
  },
  {
   "type": "text",
   "text": "Je note que l'accusée refuse de se lever. Insoumission ?"
  },
  {
   "type": "speech",
   "speaker": "FRANÇOIS",
   "lines": [
    "Fondations, monsieur le juge. Elle n'en a pas, mais elle a ses positions."
   ]
  },
  {
   "type": "speech",
   "speaker": "DANDIN",
   "lines": [
    "Qu'elle s'exprime par représentant, alors. Identité ?"
   ]
  },
  {
   "type": "speech",
   "speaker": "FRANÇOIS",
   "lines": [
    "Bergerie de la baie. Née en deux mille neuf, l'été.",
    "Quarante-six mètres quatre-vingt-dix de long, vingt et quelques de large,",
    "Bois du pays sur terre battue, sans étage et sans garage,",
    "Comme les granges d'autrefois au bord des prés-salés.",
    "Profession : maison de quatre cents moutons. Casier : hélas, tassé :",
    "Condamnée en dix-sept, en dix-huit, en vingt-deux, en vingt-cinq...",
    "Pour être née sans papiers."
   ]
  },
  {
   "type": "speech",
   "speaker": "DANDIN",
   "lines": [
    "Une sans-papiers de bois ! Le sphinx",
    "Administratif a encore frappé. Signes particuliers ?"
   ]
  },
  {
   "type": "speech",
   "speaker": "FRANÇOIS",
   "lines": [
    "Elle sent la laine mouillée et le foin de juillet.",
    "Les hirondelles nichent dans ses poutres, un crapaud",
    "Loge sous son abreuvoir, et quand le vent est au suroît,",
    "Elle chante — la charpente travaille, c'est sa manière",
    "De causer."
   ]
  },
  {
   "type": "speech",
   "speaker": "DANDIN",
   "lines": [
    "Une accusée qui chante et loge son adversaire !",
    "Voilà qui commence bien. Accusation, réquisitoire !",
    "Et par pitié, monsieur Chicaneau : bref. La Cour veut boire...",
    "Veut croire, veux-je dire, que vous savez faire court."
   ]
  },
  {
   "type": "scene",
   "text": "Scène 3"
  },
  {
   "type": "text",
   "text": "Les mêmes. Réquisitoire, témoins, plaidoirie."
  },
  {
   "type": "speech",
   "speaker": "CHICANEAU",
   "lines": []
  },
  {
   "type": "dir",
   "text": "(se levant, déroulant un listing qui traverse toute la scène)"
  },
  {
   "type": "text",
   "text": "Messieurs ! Quand je considère la création du monde,"
  },
  {
   "type": "text",
   "text": "La formation des océans, la dérive de l'onde"
  },
  {
   "type": "text",
   "text": "Primitive, l'apparition — majestueuse — des premiers batraciens,"
  },
  {
   "type": "text",
   "text": "Trois cent soixante millions d'années avant les chrétiens..."
  },
  {
   "type": "speech",
   "speaker": "DANDIN",
   "lines": [
    "Passez au déluge !"
   ]
  },
  {
   "type": "speech",
   "speaker": "CHICANEAU",
   "lines": [
    "Le déluge, justement, parlons-en ! Premier grand chantier",
    "Non déclaré ! Quarante jours de précipitations sans enquête",
    "Publique ! Une arche — une ARCHE, messieurs ! — bâtie sans permis, sans requête,",
    "En zone inondable ! Et QUI dedans ? Des moutons ! Déjà !",
    "L'histoire, messieurs, n'est qu'un éternel cas",
    "De récidive pastorale !"
   ]
  },
  {
   "type": "speech",
   "speaker": "DANDIN",
   "lines": []
  },
  {
   "type": "dir",
   "text": "(à part)"
  },
  {
   "type": "text",
   "text": "Il a relié le déluge au dossier. Ce diable"
  },
  {
   "type": "text",
   "text": "D'homme est le plus grand plaideur que la Manche ait porté."
  },
  {
   "type": "speech",
   "speaker": "CHICANEAU",
   "lines": [
    "J'en viens aux faits ! Deux mille quatre : permis refusé ! L'exploitant, buté,",
    "Bâtit ! Deux mille onze : un ministre — un MINISTRE, messieurs —",
    "Ose dire « régularisez » ! Un ministre, ce monstrueux",
    "Mélange d'élu et de bureau, prétend défaire",
    "Ce que le droit a noué ! Heureusement, la sphère",
    "Judiciaire veillait : annulé ! Puis appel : annulé !",
    "Conseil d'État : circulez ! Démolition : ordonnée ! Astreinte : soixante !",
    "Et l'on voudrait aujourd'hui, dans cette cour bêlante,",
    "Rejuger vingt ans de victoires ? Jamais ! Je réclame :",
    "La démolition ! La remise en état ! Et pour l'âme",
    "Du crapaud calamite, humilié vingt années durant :",
    "Un euro symbolique... par insecte mangé sous l'abreuvoir ! Comptant !"
   ]
  },
  {
   "type": "speech",
   "speaker": "DANDIN",
   "lines": [
    "Combien d'insectes ?"
   ]
  },
  {
   "type": "speech",
   "speaker": "CHICANEAU",
   "lines": [
    "L'expertise dira. Je provisionne à douze millions."
   ]
  },
  {
   "type": "speech",
   "speaker": "DANDIN",
   "lines": []
  },
  {
   "type": "dir",
   "text": "(sonnant la casserole)"
  },
  {
   "type": "text",
   "text": "La provision est rejetée pour cause de vertige. Champion"
  },
  {
   "type": "text",
   "text": "Toutefois du chiffre, monsieur Chicaneau. La défense !"
  },
  {
   "type": "speech",
   "speaker": "L'INTIMÉ",
   "lines": []
  },
  {
   "type": "dir",
   "text": "(se levant, majestueux)"
  },
  {
   "type": "text",
   "text": "Monsieur le juge, je serai bref."
  },
  {
   "type": "speech",
   "speaker": "DANDIN",
   "lines": []
  },
  {
   "type": "dir",
   "text": "(à part)"
  },
  {
   "type": "text",
   "text": "Ils disent tous ça."
  },
  {
   "type": "speech",
   "speaker": "L'INTIMÉ",
   "lines": [
    "Trois points, une experte, un témoin. Primo : l'offense.",
    "On accuse ma cliente d'être trop grande. Trop grande pour qui ?",
    "Pour les moutons qu'elle abrite ? Ils la trouvent exiguë",
    "Les soirs de tempête, quand ils s'y serrent à quatre cents.",
    "Trop grande pour le paysage ? Elle est en bois, elle a le teint",
    "Du pays, elle vieillit en gris d'herbu comme les clôtures.",
    "La baie l'a adoptée : demandez aux hirondelles si l'architecture",
    "Les dérange ! Secundo : l'utilité. Sans moutons, pas d'herbus",
    "Tondus ; sans herbus tondus, plus de prés-salés ; sans prés-salés, plus",
    "D'agneaux ; sans agneaux, plus de bergers ; sans bergers, la friche.",
    "Et dans la friche, messieurs, savez-vous qui trinque ? L'affiche",
    "Même de la partie adverse : le crapaud ! Car — tertio,",
    "Et c'est ici que je m'incline devant la science — j'appelle au ratio...",
    "À la barre l'experte : mademoiselle Isabelle !"
   ]
  },
  {
   "type": "speech",
   "speaker": "ISABELLE",
   "lines": []
  },
  {
   "type": "dir",
   "text": "(s'avançant, carnet en main)"
  },
  {
   "type": "text",
   "text": "Merci. Je serai brève — moi, c'est vrai. J'étudie depuis deux ans, à la belle"
  },
  {
   "type": "text",
   "text": "Étoile, les amphibiens de la baie : pélodytes, calamites,"
  },
  {
   "type": "text",
   "text": "Rainettes. Voici mes relevés — et notez que mes visites,"
  },
  {
   "type": "text",
   "text": "Mon père le confirmera, ne mentent jamais : j'ai sa rigueur,"
  },
  {
   "type": "text",
   "text": "Sans ses conclusions. Résultat : le meilleur indicateur"
  },
  {
   "type": "text",
   "text": "De présence du crapaud calamite dans le secteur,"
  },
  {
   "type": "text",
   "text": "Ce n'est ni la dune nue, ni la friche, ni le parking :"
  },
  {
   "type": "text",
   "text": "C'est le troupeau. Les moutons tondent, piétinent — un pressing"
  },
  {
   "type": "text",
   "text": "Doux qui rouvre les mares temporaires où le calamite pond."
  },
  {
   "type": "text",
   "text": "Leurs bouses nourrissent les insectes ; les insectes font"
  },
  {
   "type": "text",
   "text": "Le menu du crapaud. Autour de cette bergerie, j'ai compté"
  },
  {
   "type": "text",
   "text": "Quatre fois plus de calamites qu'ailleurs. En résumé et en vérité :"
  },
  {
   "type": "text",
   "text": "Détruire la bergerie pour sauver le crapaud, c'est"
  },
  {
   "type": "text",
   "text": "Brûler la crèche pour protéger les enfants. J'ai terminé. Et c'est"
  },
  {
   "type": "text",
   "text": "Prouvé, chiffré, signé."
  },
  {
   "type": "speech",
   "speaker": "CHICANEAU",
   "lines": []
  },
  {
   "type": "dir",
   "text": "(bondissant)"
  },
  {
   "type": "text",
   "text": "Objection ! L'experte est ma fille !"
  },
  {
   "type": "speech",
   "speaker": "ISABELLE",
   "lines": [
    "Raison de plus : vous savez que je ne plie",
    "Jamais sur un chiffre. Vous m'avez élevée ainsi."
   ]
  },
  {
   "type": "speech",
   "speaker": "CHICANEAU",
   "lines": []
  },
  {
   "type": "dir",
   "text": "(touché, à part)"
  },
  {
   "type": "text",
   "text": "La peste soit de l'éducation réussie."
  },
  {
   "type": "speech",
   "speaker": "L'INTIMÉ",
   "lines": [
    "Et maintenant, monsieur le juge, mon témoin principal !"
   ]
  },
  {
   "type": "dir",
   "text": "(Il désigne le terrarium.)"
  },
  {
   "type": "text",
   "text": "Le sieur Calamite, crapaud de son état, natif du littoral,"
  },
  {
   "type": "text",
   "text": "Domicilié sous l'abreuvoir de l'accusée, côté levant !"
  },
  {
   "type": "text",
   "text": "Témoin, jurez de coasser toute la vérité !"
  },
  {
   "type": "dir",
   "text": "(Silence. Le crapaud gonfle sa gorge. Puis un coassement sonore.)"
  },
  {
   "type": "speech",
   "speaker": "DANDIN",
   "lines": []
  },
  {
   "type": "dir",
   "text": "(gravement)"
  },
  {
   "type": "text",
   "text": "Le témoin a juré. Qu'il dépose."
  },
  {
   "type": "speech",
   "speaker": "L'INTIMÉ",
   "lines": [
    "J'interprète, avec l'accord de la Cour : le témoin déclare",
    "Qu'il est né dans la dune, qu'il a goûté du hangar",
    "Agricole, du gîte rural et du rond-point fleuri,",
    "Et qu'il n'a jamais si bien vécu que sous l'abri",
    "De l'accusée, où le couvert est mis chaque soir à la nuit tombée,",
    "Mouches à volonté, vue sur les mares, ambiance feutrée",
    "De laine. Il ajoute — et je cite — « couac » : rien",
    "Ne l'a jamais dérangé, sauf, une fois l'an, le crapaudomètre. Bien",
    "Entendu, la partie adverse contestera la traduction..."
   ]
  },
  {
   "type": "speech",
   "speaker": "CHICANEAU",
   "lines": [
    "Je la conteste ! Ce coassement était un appel au secours !"
   ]
  },
  {
   "type": "speech",
   "speaker": "L'INTIMÉ",
   "lines": [
    "C'était un rot de satisfaction, monsieur ! Le témoin sort d'un festin d'ampleur !"
   ]
  },
  {
   "type": "speech",
   "speaker": "CHICANEAU",
   "lines": [
    "Appel au secours !"
   ]
  },
  {
   "type": "speech",
   "speaker": "L'INTIMÉ",
   "lines": [
    "Rot de bien-être !"
   ]
  },
  {
   "type": "speech",
   "speaker": "DANDIN",
   "lines": []
  },
  {
   "type": "dir",
   "text": "(sonnant la casserole)"
  },
  {
   "type": "text",
   "text": "La Cour tranchera entre le rot et l'appel ! Maître,"
  },
  {
   "type": "text",
   "text": "Concluez !"
  },
  {
   "type": "speech",
   "speaker": "L'INTIMÉ",
   "lines": [
    "Je conclus. Pour émouvoir enfin les cœurs de pierre,",
    "J'appelle... la famille de l'accusée ! Ses enfants ! La litière",
    "De ses entrailles de bois !"
   ]
  },
  {
   "type": "dir",
   "text": "(FRANÇOIS fait entrer trois agnelets, qui bêlent.)"
  },
  {
   "type": "text",
   "text": "Venez, pauvres orphelins qu'on veut priver de toit !"
  },
  {
   "type": "text",
   "text": "Venez faire parler vos laines et vos émois !"
  },
  {
   "type": "text",
   "text": "Où dormiront-ils, messieurs, quand soufflera janvier ?"
  },
  {
   "type": "text",
   "text": "Sous une bâche ? Un tunnel ? Le droit sera-t-il plus fier"
  },
  {
   "type": "text",
   "text": "Quand la pluie normande aura le dernier mot ? Regardez-les, et osez"
  },
  {
   "type": "text",
   "text": "Dire à ces trois-là que leur maison est une abstraction cadastrale ! J'ai... posé"
  },
  {
   "type": "text",
   "text": "Ma voix. Elle tremble. Tant pis. La défense a fini."
  },
  {
   "type": "speech",
   "speaker": "DANDIN",
   "lines": []
  },
  {
   "type": "dir",
   "text": "(bouleversé, se mouchant dans sa manche)"
  },
  {
   "type": "text",
   "text": "Ah !... Je suis juge... je ne dois pas... Ils sont si petits..."
  },
  {
   "type": "text",
   "text": "Celui du milieu me regarde avec les yeux de ma tante Eulalie..."
  },
  {
   "type": "text",
   "text": "Qu'on remette les témoins à leur maman ! Et que la Cour rallie"
  },
  {
   "type": "text",
   "text": "Son délibéré avant de fondre en jurisprudence !"
  },
  {
   "type": "text",
   "text": "LA COMTESSE"
  },
  {
   "type": "dir",
   "text": "(essuyant une larme, à Chicaneau)"
  },
  {
   "type": "text",
   "text": "Mouchez-vous donc, mon ami. Vous pleurez sur l'audience."
  },
  {
   "type": "speech",
   "speaker": "CHICANEAU",
   "lines": [
    "Je ne pleure pas, madame : je transpire des yeux. C'est le trac",
    "Des grandes plaidoiries. Et puis ma fille était... Elle a un de ces knacks...",
    "Un de ces talents, là, à la barre... Tout de même : quatre fois plus",
    "De crapauds chez le berger... Si c'est vrai, nous avons plaidé, moulu,",
    "Vingt ans... contre notre propre crapaud ?",
    "LA COMTESSE",
    "Chut. On délibère."
   ]
  },
  {
   "type": "scene",
   "text": "Scène 4"
  },
  {
   "type": "text",
   "text": "Les mêmes. Le verdict."
  },
  {
   "type": "speech",
   "speaker": "DANDIN",
   "lines": []
  },
  {
   "type": "dir",
   "text": "(solennel, debout)"
  },
  {
   "type": "text",
   "text": "La Cour, après en avoir délibéré avec elle-même —"
  },
  {
   "type": "text",
   "text": "Ce fut rapide, nous étions d'accord — rend l'arrêt suprême"
  },
  {
   "type": "text",
   "text": "Que voici. Attendu que les jugements des vraies cours sont rendus,"
  },
  {
   "type": "text",
   "text": "Et que nul ici n'a pouvoir de les défaire — entendu ! —"
  },
  {
   "type": "text",
   "text": "Mais attendu qu'il reste, au-dessus des astreintes et des rôles,"
  },
  {
   "type": "text",
   "text": "Un tribunal que rien ne ferme : celui-là seul où la parole"
  },
  {
   "type": "text",
   "text": "Est donnée au crapaud, au mouton, à la charpente et au berger ;"
  },
  {
   "type": "text",
   "text": "Attendu que ce tribunal-ci, dûment casserolé, siégeant"
  },
  {
   "type": "text",
   "text": "Face à la baie, a entendu ce que vingt ans de prétoires"
  },
  {
   "type": "text",
   "text": "N'avaient pas écouté : que la bergerie chante au suroît, que les déboires"
  },
  {
   "type": "text",
   "text": "Du calamite commencent où finissent les troupeaux,"
  },
  {
   "type": "text",
   "text": "Et qu'on ne protège pas un paysage en chassant ce qui le rend beau ;"
  },
  {
   "type": "text",
   "text": "Attendu que le ministre avait dit oui, que le tribunal a dit non,"
  },
  {
   "type": "text",
   "text": "Et qu'entre le oui et le non, le crapaud, lui, dit « couac » — ce qui, en bon"
  },
  {
   "type": "text",
   "text": "Normand, signifie « p't-être ben » ; attendu enfin qu'une loi, même Littoral,"
  },
  {
   "type": "text",
   "text": "N'a jamais eu vocation à tondre plus ras que le moral"
  },
  {
   "type": "text",
   "text": "D'un honnête homme ; la Cour, au nom des herbus souverains :"
  },
  {
   "type": "text",
   "text": "DIT que la bergerie est innocente d'être utile ; DIT que le serein"
  },
  {
   "type": "text",
   "text": "Calamite est déclaré premier habitant protégé DE la bergerie — et non contre ;"
  },
  {
   "type": "text",
   "text": "NOMME ledit crapaud syndic bénévole des lieux, avec pour montre"
  },
  {
   "type": "text",
   "text": "Et salaire : mouches à discrétion ; INVITE les vraies cours, les ministres,"
  },
  {
   "type": "text",
   "text": "Les préfets, les maires et les vigilances à relire ce sinistre"
  },
  {
   "type": "text",
   "text": "Dossier à la lumière d'un fait nouveau : le rire de ce soir ;"
  },
  {
   "type": "text",
   "text": "CONDAMNE Vigilance Crapaud, à titre de dommages, à parrainer un ouvroir..."
  },
  {
   "type": "text",
   "text": "Un agneau, veux-je dire, prénommé Calamite, qu'elle visitera aux fêtes ;"
  },
  {
   "type": "text",
   "text": "CONDAMNE le berger à fournir aux parties, chaque Saint-Michel, une assiette"
  },
  {
   "type": "text",
   "text": "De fromages de brebis, sans étiquette et sans huissier ;"
  },
  {
   "type": "text",
   "text": "Et ORDONNE l'exécution immédiate, nonobstant tout, monsieur le greffier !"
  },
  {
   "type": "dir",
   "text": "(Il frappe la casserole. Bêlements. Coassement.)"
  },
  {
   "type": "speech",
   "speaker": "CHICANEAU",
   "lines": [
    "Je... c'est... Attendez... Ai-je perdu ou gagné ?"
   ]
  },
  {
   "type": "speech",
   "speaker": "L'INTIMÉ",
   "lines": [
    "Ni l'un ni l'autre, monsieur : vous avez déjeuné.",
    "Le fromage arrive."
   ]
  },
  {
   "type": "speech",
   "speaker": "CHICANEAU",
   "lines": [
    "Je vais faire appel !"
   ]
  },
  {
   "type": "speech",
   "speaker": "ISABELLE",
   "lines": []
  },
  {
   "type": "dir",
   "text": "(s'avançant avec Léandre)"
  },
  {
   "type": "text",
   "text": "Père, avant l'appel, une petite lecture :"
  },
  {
   "type": "text",
   "text": "Vous avez signé ceci hier. Trois fois. Belle signature."
  },
  {
   "type": "speech",
   "speaker": "CHICANEAU",
   "lines": []
  },
  {
   "type": "dir",
   "text": "(lisant)"
  },
  {
   "type": "text",
   "text": "Le mariage... Ah, c'est vrai... Piégé par acte authentique..."
  },
  {
   "type": "dir",
   "text": "(Il regarde Léandre, puis le public, puis soupire.)"
  },
  {
   "type": "text",
   "text": "Bon. Après tout... Ce garçon a une belle pratique"
  },
  {
   "type": "text",
   "text": "Du droit. Et sa future épouse compte les crapauds mieux que moi."
  },
  {
   "type": "text",
   "text": "Qu'ils s'assignent l'un l'autre à perpétuité ! Mais je pose, en père de loi,"
  },
  {
   "type": "text",
   "text": "Une condition irrévocable : le contrat de mariage"
  },
  {
   "type": "text",
   "text": "Fera cent quarante pages minimum, et c'est MOI qui rédige !"
  },
  {
   "type": "speech",
   "speaker": "LÉANDRE",
   "lines": [
    "Adjugé, beau-père !"
   ]
  },
  {
   "type": "speech",
   "speaker": "DANDIN",
   "lines": []
  },
  {
   "type": "dir",
   "text": "(ému)"
  },
  {
   "type": "text",
   "text": "Mon fils se marie ! La Cour ordonne la noce séance tenante !"
  },
  {
   "type": "text",
   "text": "C'est mon dernier jugement... et le premier qui me chante."
  },
  {
   "type": "text",
   "text": "LA COMTESSE"
  },
  {
   "type": "dir",
   "text": "(à Chicaneau, minaudant)"
  },
  {
   "type": "text",
   "text": "Monsieur le secrétaire... puisque tout transige, aujourd'hui..."
  },
  {
   "type": "text",
   "text": "Je vous rends votre titre. Et j'y joins une offre : il m'ennuie,"
  },
  {
   "type": "text",
   "text": "Le soir, de relire seule mes conclusions. Quatorze"
  },
  {
   "type": "text",
   "text": "Dossiers m'attendent au coin du feu. Il y faudrait une force"
  },
  {
   "type": "text",
   "text": "D'appoint. Un œil. Une plume. Un... co-requérant."
  },
  {
   "type": "speech",
   "speaker": "CHICANEAU",
   "lines": []
  },
  {
   "type": "dir",
   "text": "(troublé)"
  },
  {
   "type": "text",
   "text": "Madame... on ne m'avait jamais parlé si juridiquement."
  },
  {
   "type": "text",
   "text": "Co-requérant... Le plus beau mot de la langue après « nonobstant »."
  },
  {
   "type": "text",
   "text": "J'accepte. Mais on signe un protocole !"
  },
  {
   "type": "text",
   "text": "LA COMTESSE"
  },
  {
   "type": "text",
   "text": "En trois exemplaires, mon ami. Comme toutes les choses folles."
  },
  {
   "type": "speech",
   "speaker": "FRANÇOIS",
   "lines": []
  },
  {
   "type": "dir",
   "text": "(qui a tout regardé en souriant)"
  },
  {
   "type": "text",
   "text": "Et voilà comment, en un après-midi, sans dépens,"
  },
  {
   "type": "text",
   "text": "Une casserole a marié deux couples et un crapaud. Le temps"
  },
  {
   "type": "text",
   "text": "Des hommes est étrange : il leur faut vingt ans pour se fâcher"
  },
  {
   "type": "text",
   "text": "Et un coup de théâtre pour s'entendre. Allons dîner. J'ai fait toucher..."
  },
  {
   "type": "text",
   "text": "J'ai fait traire les brebis : il y a de la tomme pour tout le monde,"
  },
  {
   "type": "text",
   "text": "Même pour les vigilances. La baie est bonne fille : elle inonde,"
  },
  {
   "type": "text",
   "text": "Mais elle nourrit."
  },
  {
   "type": "scene",
   "text": "Scène 5"
  },
  {
   "type": "text",
   "text": "Tous, face au public."
  },
  {
   "type": "speech",
   "speaker": "FRANÇOIS",
   "lines": [
    "Bonnes gens d'Avranches, avant de nous quitter,",
    "Un mot. Ce que vous avez vu est une comédie : la vérité",
    "Est plus têtue. À l'heure où nous jouons, la vraie bergerie,",
    "Là-bas, à deux lieues, compte ses jours et ses agneaux. La féerie",
    "Du théâtre acquitte en une soirée ce que vingt ans ont condamné ;",
    "Le rideau, hélas, ne fait pas jurisprudence. Mais rien n'est terminé",
    "Tant qu'un pays se souvient qu'il aime ses bergers."
   ]
  },
  {
   "type": "speech",
   "speaker": "PETIT-JEAN",
   "lines": [
    "Trente-cinq mille signatures l'ont déjà dit sans se décourager :",
    "Ce soir, vous étiez quelques centaines de plus à l'entendre."
   ]
  },
  {
   "type": "speech",
   "speaker": "DANDIN",
   "lines": [
    "Et si quelque spectateur, rentrant chez lui, se sent descendre",
    "Une envie de procès contre son voisin, sa haie, sa tondeuse,",
    "Qu'il médite l'arrêt Calamite, jurisprudence heureuse :",
    "Avant d'assigner ce qui vous dérange, mes amis,",
    "Vérifiez d'abord que le crapaud est de votre avis.",
    "LA COMTESSE",
    "Défendre la nature est le plus beau des combats..."
   ]
  },
  {
   "type": "speech",
   "speaker": "CHICANEAU",
   "lines": [
    "... à condition de ne pas la défendre contre ceux d'en bas",
    "Qui la font vivre à l'année, bottes aux pieds, sans jamais plaider."
   ]
  },
  {
   "type": "speech",
   "speaker": "L'INTIMÉ",
   "lines": [
    "L'auteur de ces vers boiteux descend, dit-on, de Jean Racine."
   ]
  },
  {
   "type": "speech",
   "speaker": "ISABELLE",
   "lines": [
    "Trois siècles et demi plus tard, la pomme roule loin de la racine..."
   ]
  },
  {
   "type": "speech",
   "speaker": "LÉANDRE",
   "lines": [
    "Mais elle roule en riant, et c'est là l'essentiel."
   ]
  },
  {
   "type": "speech",
   "speaker": "TOUS",
   "lines": []
  },
  {
   "type": "dir",
   "text": "(saluant)"
  },
  {
   "type": "text",
   "text": "Si la pièce vous plut, dites-le à la baie entière ;"
  },
  {
   "type": "text",
   "text": "Sinon... assignez le ciel, il a de bons avocats — et vingt ans devant lui, derrière !"
  },
  {
   "type": "speech",
   "speaker": "RIDEAU",
   "lines": [
    "« Le Crapaud et le Berger ou Les Nouveaux Plaideurs », farce en trois actes et en vers de Gilles de Chassey,",
    "descendant de Jean Racine, librement inspirée des « Plaideurs » (1668) et de l'histoire vraie de la bergerie de la baie.",
    "Créée au théâtre d'Avranches à l'été 2026, puis représentée au Prieuré Saint-Léonard et à la bergerie de François",
    "Cerbonney, le Berger de la baie. Une production VIVA ARTIST, le label de production tous médias du Prieuré",
    "Saint-Léonard. — Juillet 2026.",
    "20 €"
   ]
  }
 ]
};
